import { i18n } from "../../translate/i18n";

// Strings locais do painel ERP (pt/en/es). Não usa src/translate/languages/*.
const messages = {
  pt: {
    title: "ERP do provedor",
    linkTitle: "Vincular ao ERP",
    linkHint: "Busque o cadastro do cliente pelo CPF/CNPJ e vincule a este contato.",
    noIntegration: "Configure uma integração SGP/IXC em Filas & Chatbot → Integrações.",
    integration: "Integração",
    cpfCnpj: "CPF/CNPJ",
    password: "Senha da central (SGP)",
    passwordHint: "Somente para SGP com senha do assinante.",
    search: "Buscar",
    searching: "Buscando...",
    noResults: "Nenhum cadastro encontrado para este CPF/CNPJ.",
    linkButton: "Vincular",
    linkCustomer: "Vincular cliente",
    linked: "Vinculado",
    unlink: "Desvincular",
    unlinkConfirmTitle: "Desvincular do ERP?",
    unlinkConfirm: "O contato deixará de mostrar os dados do ERP. Você pode vincular novamente depois.",
    refresh: "Atualizar",
    contracts: "Contratos",
    noContracts: "Nenhum contrato encontrado.",
    contract: "Contrato",
    plan: "Plano",
    value: "Valor",
    address: "Endereço",
    connection: "Conexão",
    online: "Online",
    offline: "Offline",
    unknownState: "Não informado",
    login: "Login",
    ip: "IP",
    lastConnection: "Última conexão",
    signal: "Sinal ONU",
    signalNotProvided: "não informado pelo ERP",
    connType: "Tipo",
    olt: "OLT",
    onuSerial: "Serial ONU",
    groupConnection: "Conexão",
    groupFiber: "Fibra / ONU",
    groupCpe: "Roteador (CPE)",
    sessionUsage: "Consumo na sessão",
    nas: "NAS",
    lastDisconnect: "Última desconexão",
    lastSessions: "Últimas conexões",
    sessionOpen: "em andamento",
    signalGood: "bom",
    signalWarn: "atenção",
    signalBad: "crítico",
    uptime: "Tempo conectado",
    mac: "MAC",
    pop: "POP",
    wanIp: "IP WAN",
    equipment: "Equipamento",
    wifi: "Wi-Fi",
    wifiOff: "desligada",
    lanDevices: "Dispositivos na rede",
    serviceOrders: "O.S. em aberto",
    osScheduled: "agendada",
    osOpened: "aberta",
    sendStatus: "Enviar status no chat",
    invoices: "Faturas em aberto",
    noInvoices: "Nenhuma fatura em aberto.",
    dueDate: "Vencimento",
    amount: "Valor",
    status: "Status",
    overdue: "Vencida",
    upcoming: "A vencer",
    sendInChat: "Enviar no chat",
    closeAfterSend: "Encerrar o atendimento após enviar",
    sentAndClosed: "Enviado e atendimento encerrado.",
    pix: "PIX",
    sendAll: "Enviar todas",
    actions: "Ações",
    trustUnblock: "Desbloqueio de confiança",
    trustUnblockHint: "Disponível quando há contrato suspenso ou bloqueado.",
    trustUnblockConfirmTitle: "Desbloqueio de confiança",
    trustUnblockConfirm: "Solicitar ao ERP a liberação por confiança do contrato {contract}?",
    needsPassword: "Esta integração SGP exige a senha do assinante para consultar.",
    source: "Fonte",
    consultedAt: "consultado às",
    sent: "Mensagem enviada no chat.",
    linkedOk: "Contato vinculado ao ERP.",
    unlinkedOk: "Vínculo removido.",
    unblockOk: "Solicitação enviada ao ERP.",
    noTicket: "Abra o contato a partir de um atendimento para enviar mensagens.",
    statusActive: "Ativo",
    statusSuspended: "Suspenso",
    statusBlocked: "Bloqueado",
    statusCancelled: "Cancelado",
    statusPending: "Pendente",
    statusUnknown: "-",
    writeback: "Registrar no ERP",
    writebackTitle: "Registrar no ERP",
    writebackAction: "O que abrir",
    writebackNote: "Anotação",
    writebackOs: "Ordem de serviço",
    writebackText: "Texto (editável)",
    writebackTitleField: "Título",
    writebackSend: "Enviar ao ERP",
    writebackOk: "Registrado no ERP: #{{id}} {{protocol}}",
    writebackUnsupported: "Este ERP não permite esta ação.",
    writebackLoading: "Preparando resumo...",
    writebackCancel: "Cancelar"
  },
  en: {
    title: "ISP ERP",
    linkTitle: "Link to ERP",
    linkHint: "Search the customer record by CPF/CNPJ and link it to this contact.",
    noIntegration: "Set up an SGP/IXC integration in Queues & Chatbot → Integrations.",
    integration: "Integration",
    cpfCnpj: "CPF/CNPJ",
    password: "Portal password (SGP)",
    passwordHint: "Only for SGP with subscriber password.",
    search: "Search",
    searching: "Searching...",
    noResults: "No record found for this CPF/CNPJ.",
    linkButton: "Link",
    linkCustomer: "Link customer",
    linked: "Linked",
    unlink: "Unlink",
    unlinkConfirmTitle: "Unlink from ERP?",
    unlinkConfirm: "The contact will stop showing ERP data. You can link it again later.",
    refresh: "Refresh",
    contracts: "Contracts",
    noContracts: "No contracts found.",
    contract: "Contract",
    plan: "Plan",
    value: "Value",
    address: "Address",
    connection: "Connection",
    online: "Online",
    offline: "Offline",
    unknownState: "Unknown",
    login: "Login",
    ip: "IP",
    lastConnection: "Last connection",
    signal: "ONU signal",
    signalNotProvided: "not provided by the ERP",
    connType: "Type",
    olt: "OLT",
    onuSerial: "ONU serial",
    groupConnection: "Connection",
    groupFiber: "Fiber / ONU",
    groupCpe: "Router (CPE)",
    sessionUsage: "Session usage",
    nas: "NAS",
    lastDisconnect: "Last disconnect",
    lastSessions: "Recent sessions",
    sessionOpen: "ongoing",
    signalGood: "good",
    signalWarn: "warning",
    signalBad: "critical",
    uptime: "Uptime",
    mac: "MAC",
    pop: "POP",
    wanIp: "WAN IP",
    equipment: "Device",
    wifi: "Wi-Fi",
    wifiOff: "off",
    lanDevices: "LAN devices",
    serviceOrders: "Open service orders",
    osScheduled: "scheduled",
    osOpened: "opened",
    sendStatus: "Send status in chat",
    invoices: "Open invoices",
    noInvoices: "No open invoices.",
    dueDate: "Due date",
    amount: "Amount",
    status: "Status",
    overdue: "Overdue",
    upcoming: "Upcoming",
    sendInChat: "Send in chat",
    closeAfterSend: "Close the ticket after sending",
    sentAndClosed: "Sent and ticket closed.",
    pix: "PIX",
    sendAll: "Send all",
    actions: "Actions",
    trustUnblock: "Trust unblock",
    trustUnblockHint: "Available when a contract is suspended or blocked.",
    trustUnblockConfirmTitle: "Trust unblock",
    trustUnblockConfirm: "Ask the ERP to unblock contract {contract} on trust?",
    needsPassword: "This SGP integration requires the subscriber password.",
    source: "Source",
    consultedAt: "fetched at",
    sent: "Message sent in chat.",
    linkedOk: "Contact linked to ERP.",
    unlinkedOk: "Link removed.",
    unblockOk: "Request sent to the ERP.",
    noTicket: "Open the contact from a ticket to send messages.",
    statusActive: "Active",
    statusSuspended: "Suspended",
    statusBlocked: "Blocked",
    statusCancelled: "Cancelled",
    statusPending: "Pending",
    statusUnknown: "-",
    writeback: "Register in ERP",
    writebackTitle: "Register in ERP",
    writebackAction: "What to open",
    writebackNote: "Note",
    writebackOs: "Service order",
    writebackText: "Text (editable)",
    writebackTitleField: "Title",
    writebackSend: "Send to ERP",
    writebackOk: "Registered in ERP: #{{id}} {{protocol}}",
    writebackUnsupported: "This ERP does not allow this action.",
    writebackLoading: "Preparing summary...",
    writebackCancel: "Cancel"
  },
  es: {
    title: "ERP del proveedor",
    linkTitle: "Vincular al ERP",
    linkHint: "Busque el registro del cliente por CPF/CNPJ y vincúlelo a este contacto.",
    noIntegration: "Configure una integración SGP/IXC en Colas & Chatbot → Integraciones.",
    integration: "Integración",
    cpfCnpj: "CPF/CNPJ",
    password: "Contraseña del portal (SGP)",
    passwordHint: "Solo para SGP con contraseña del abonado.",
    search: "Buscar",
    searching: "Buscando...",
    noResults: "No se encontró registro para este CPF/CNPJ.",
    linkButton: "Vincular",
    linkCustomer: "Vincular cliente",
    linked: "Vinculado",
    unlink: "Desvincular",
    unlinkConfirmTitle: "¿Desvincular del ERP?",
    unlinkConfirm: "El contacto dejará de mostrar los datos del ERP. Puede vincularlo de nuevo después.",
    refresh: "Actualizar",
    contracts: "Contratos",
    noContracts: "No se encontraron contratos.",
    contract: "Contrato",
    plan: "Plan",
    value: "Valor",
    address: "Dirección",
    connection: "Conexión",
    online: "En línea",
    offline: "Desconectado",
    unknownState: "No informado",
    login: "Usuario",
    ip: "IP",
    lastConnection: "Última conexión",
    signal: "Señal ONU",
    signalNotProvided: "no informado por el ERP",
    connType: "Tipo",
    olt: "OLT",
    onuSerial: "Serial ONU",
    groupConnection: "Conexión",
    groupFiber: "Fibra / ONU",
    groupCpe: "Router (CPE)",
    sessionUsage: "Consumo de la sesión",
    nas: "NAS",
    lastDisconnect: "Última desconexión",
    lastSessions: "Últimas conexiones",
    sessionOpen: "en curso",
    signalGood: "bueno",
    signalWarn: "atención",
    signalBad: "crítico",
    uptime: "Tiempo conectado",
    mac: "MAC",
    pop: "POP",
    wanIp: "IP WAN",
    equipment: "Equipo",
    wifi: "Wi-Fi",
    wifiOff: "apagada",
    lanDevices: "Dispositivos en la red",
    serviceOrders: "Órdenes de servicio abiertas",
    osScheduled: "agendada",
    osOpened: "abierta",
    sendStatus: "Enviar estado en el chat",
    invoices: "Facturas abiertas",
    noInvoices: "Sin facturas abiertas.",
    dueDate: "Vencimiento",
    amount: "Valor",
    status: "Estado",
    overdue: "Vencida",
    upcoming: "Por vencer",
    sendInChat: "Enviar en el chat",
    closeAfterSend: "Cerrar la atención después de enviar",
    sentAndClosed: "Enviado y atención cerrada.",
    pix: "PIX",
    sendAll: "Enviar todas",
    actions: "Acciones",
    trustUnblock: "Desbloqueo de confianza",
    trustUnblockHint: "Disponible cuando hay contrato suspendido o bloqueado.",
    trustUnblockConfirmTitle: "Desbloqueo de confianza",
    trustUnblockConfirm: "¿Solicitar al ERP la liberación por confianza del contrato {contract}?",
    needsPassword: "Esta integración SGP exige la contraseña del abonado.",
    source: "Fuente",
    consultedAt: "consultado a las",
    sent: "Mensaje enviado en el chat.",
    linkedOk: "Contacto vinculado al ERP.",
    unlinkedOk: "Vínculo eliminado.",
    unblockOk: "Solicitud enviada al ERP.",
    noTicket: "Abra el contacto desde una atención para enviar mensajes.",
    statusActive: "Activo",
    statusSuspended: "Suspendido",
    statusBlocked: "Bloqueado",
    statusCancelled: "Cancelado",
    statusPending: "Pendiente",
    statusUnknown: "-",
    writeback: "Registrar en el ERP",
    writebackTitle: "Registrar en el ERP",
    writebackAction: "Qué abrir",
    writebackNote: "Anotación",
    writebackOs: "Orden de servicio",
    writebackText: "Texto (editable)",
    writebackTitleField: "Título",
    writebackSend: "Enviar al ERP",
    writebackOk: "Registrado en el ERP: #{{id}} {{protocol}}",
    writebackUnsupported: "Este ERP no permite esta acción.",
    writebackLoading: "Preparando resumen...",
    writebackCancel: "Cancelar"
  }
};

const currentLang = () => {
  const lang = String(i18n.language || "pt").toLowerCase().slice(0, 2);
  return messages[lang] ? lang : "pt";
};

/** t("key", { contract: "123" }) — interpola {var}. */
export const t = (key, vars) => {
  const dict = messages[currentLang()] || messages.pt;
  let text = dict[key] !== undefined ? dict[key] : messages.pt[key] !== undefined ? messages.pt[key] : key;
  if (vars) {
    Object.keys(vars).forEach(k => {
      text = text.replace(new RegExp(`\\{${k}\\}`, "g"), String(vars[k]));
    });
  }
  return text;
};

export default t;
